import { connect } from 'react-redux';

import UserAvatarCell from '../../components/Settings/UsersSettings/UserAvatarCell';

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps)(UserAvatarCell);
